/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AssociaOperatoreComuneForm } from '../model/models';
import { ComuneAdminCreationForm } from '../model/models';
import { ComuneAdminDTO } from '../model/models';
import { ComuneAdminListFilter } from '../model/models';
import { ComuneAdminUpdateForm } from '../model/models';
import { ConfigurazioneMailForm } from '../model/models';
import { ConfigurazioneMailTestRequest } from '../model/models';
import { ConfigurazioneMailValidateRequest } from '../model/models';
import { ConfigurazioneSmsForm } from '../model/models';
import { ConfigurazioneSmsTestRequest } from '../model/models';
import { ConfigurazioneSmsValidateRequest } from '../model/models';
import { ConfigurazioneTestResponse } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { OperatoreComuneDTO } from '../model/models';
import { OperatoreComuneListFilter } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelComuneAdminDTO } from '../model/models';
import { PagedModelOperatoreComuneCompactDTO } from '../model/models';
import { PagoPaConfigForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AssociaComuneOperatoreComuneRequestParams {
    id: string;
    associaOperatoreComuneForm: AssociaOperatoreComuneForm;
}

export interface CreateComuneRequestParams {
    comuneAdminCreationForm: ComuneAdminCreationForm;
}

export interface DissociaComuneOperatoreComuneRequestParams {
    id: string;
    userId: string;
}

export interface GetAllComuniRequestParams {
    filter: ComuneAdminListFilter;
    pageable: Pageable;
}

export interface GetComuneRequestParams {
    id: string;
}

export interface ListComuneOperatoriComuneRequestParams {
    id: string;
    filter: OperatoreComuneListFilter;
    pageable: Pageable;
}

export interface TestComuneConfigurazioneMailRequestParams {
    id: string;
    configurazioneMailTestRequest: ConfigurazioneMailTestRequest;
}

export interface TestComuneConfigurazioneSmsRequestParams {
    id: string;
    configurazioneSmsTestRequest: ConfigurazioneSmsTestRequest;
}

export interface UpdateComuneRequestParams {
    id: string;
    comuneAdminUpdateForm: ComuneAdminUpdateForm;
}

export interface UpdateComuneConfigurazioneMailRequestParams {
    id: string;
    configurazioneMailForm: ConfigurazioneMailForm;
}

export interface UpdateComuneConfigurazioneSmsRequestParams {
    id: string;
    configurazioneSmsForm: ConfigurazioneSmsForm;
}

export interface UpdateComunePagoPaConfigRequestParams {
    id: string;
    pagoPaConfigForm: PagoPaConfigForm;
}

export interface ValidateComuneConfigurazioneMailRequestParams {
    id: string;
    configurazioneMailValidateRequest?: ConfigurazioneMailValidateRequest;
}

export interface ValidateComuneConfigurazioneSmsRequestParams {
    id: string;
    configurazioneSmsValidateRequest?: ConfigurazioneSmsValidateRequest;
}


export interface ComuniSUPERADMINServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Associa un OP_COMUNE esistente al Comune (SUPERADMIN). Lookup by email.
     * 404 se l\&#39;email non corrisponde a un User (no creazione implicita). Idempotente. Applica la matrice authority-target: 409 se l\&#39;utente ha authority incompatibile.
     * @endpoint post /api/v1/gestione/comuni/{id}/operatori-comune
* @param requestParameters
     */
    associaComuneOperatoreComune(requestParameters: AssociaComuneOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<OperatoreComuneDTO>;

    /**
     * Crea un nuovo Comune (SUPERADMIN). Se referente_email presente, crea anche un OP_COMUNE referente.
     * 
     * @endpoint post /api/v1/gestione/comuni
* @param requestParameters
     */
    createComune(requestParameters: CreateComuneRequestParams, extraHttpRequestParams?: any): Observable<ComuneAdminDTO>;

    /**
     * Rimuovi l\&#39;associazione OP_COMUNE ↔ Comune (SUPERADMIN). Idempotente.
     * Rimuove SOLO la riga users_comuni, non lo User. Idempotente: 204 anche se l\&#39;associazione non esisteva. NIENTE check sul cardinality risultante (comuniGestiti&#x3D;[] lecito).
     * @endpoint delete /api/v1/gestione/comuni/{id}/operatori-comune/{user_id}
* @param requestParameters
     */
    dissociaComuneOperatoreComune(requestParameters: DissociaComuneOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Lista paginata e filtrata dei Comuni (SUPERADMIN). Filtri: q (containsCi nome/slug), tipologia, enabled, comune_nascosto. Default sort: nome ASC, size 20.
     * 
     * @endpoint get /api/v1/gestione/comuni
* @param requestParameters
     */
    getAllComuni(requestParameters: GetAllComuniRequestParams, extraHttpRequestParams?: any): Observable<PagedModelComuneAdminDTO>;

    /**
     * Detail di un Comune (SUPERADMIN). Le password nei blob sono mascherate.
     * 
     * @endpoint get /api/v1/gestione/comuni/{id}
* @param requestParameters
     */
    getComune(requestParameters: GetComuneRequestParams, extraHttpRequestParams?: any): Observable<ComuneAdminDTO>;

    /**
     * Lista paginata degli OP_COMUNE associati al Comune (SUPERADMIN).
     * Thin wrapper su GET /api/v1/gestione/operatori-comune?comune_id&#x3D;{id}. Filtri opzionali: q (email/nome/cognome), enabled. Default sort: email ASC, size 20. Il filtro comune_id e\&#39; forzato dal path: eventuali query param ?comune_id&#x3D;... vengono ignorati.
     * @endpoint get /api/v1/gestione/comuni/{id}/operatori-comune
* @param requestParameters
     */
    listComuneOperatoriComune(requestParameters: ListComuneOperatoriComuneRequestParams, extraHttpRequestParams?: any): Observable<PagedModelOperatoreComuneCompactDTO>;

    /**
     * Test reale configurazione mail del Comune (SUPERADMIN). Invia un\&#39;email reale al target.
     * Manda una email reale al target_email usando la configurazione del body (se presente) o quella persistita sul comune. 200 OK con esito&#x3D;OK; 422 con causa&#x3D;AUTH_FAILED|HOST_UNREACHABLE|SSL_ERROR|TIMEOUT|RECIPIENT_REJECTED su errore. Costoso: consuma quota SMTP. Per il check handshake-only usare /validate.
     * @endpoint post /api/v1/gestione/comuni/{id}/configurazione-mail/test
* @param requestParameters
     */
    testComuneConfigurazioneMail(requestParameters: TestComuneConfigurazioneMailRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneTestResponse>;

    /**
     * Test reale configurazione SMS del Comune (SUPERADMIN). Invia un SMS reale al target.
     * Manda un SMS reale al target_telefono usando la configurazione del body (se presente) o quella persistita sul comune. Costoso: Aruba fattura. Per il check login-only usare /validate.
     * @endpoint post /api/v1/gestione/comuni/{id}/configurazione-sms/test
* @param requestParameters
     */
    testComuneConfigurazioneSms(requestParameters: TestComuneConfigurazioneSmsRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneTestResponse>;

    /**
     * PUT-replace dei campi anagrafici/branding del Comune (SUPERADMIN). I blob non sono toccati.
     * 
     * @endpoint put /api/v1/gestione/comuni/{id}
* @param requestParameters
     */
    updateComune(requestParameters: UpdateComuneRequestParams, extraHttpRequestParams?: any): Observable<ComuneAdminDTO>;

    /**
     * PUT-replace del blob configurazioneMail del Comune (SUPERADMIN). Inviare PASSWORD_MASKED_PLACEHOLDER per preservare la password esistente.
     * 
     * @endpoint put /api/v1/gestione/comuni/{id}/configurazione-mail
* @param requestParameters
     */
    updateComuneConfigurazioneMail(requestParameters: UpdateComuneConfigurazioneMailRequestParams, extraHttpRequestParams?: any): Observable<ComuneAdminDTO>;

    /**
     * PUT-replace del blob configurazioneSms del Comune (SUPERADMIN).
     * 
     * @endpoint put /api/v1/gestione/comuni/{id}/configurazione-sms
* @param requestParameters
     */
    updateComuneConfigurazioneSms(requestParameters: UpdateComuneConfigurazioneSmsRequestParams, extraHttpRequestParams?: any): Observable<ComuneAdminDTO>;

    /**
     * PUT-replace del blob pagoPaConfig del Comune (SUPERADMIN).
     * 
     * @endpoint put /api/v1/gestione/comuni/{id}/pago-pa-config
* @param requestParameters
     */
    updateComunePagoPaConfig(requestParameters: UpdateComunePagoPaConfigRequestParams, extraHttpRequestParams?: any): Observable<ComuneAdminDTO>;

    /**
     * Validate handshake-only configurazione mail del Comune (SUPERADMIN). Solo Transport.connect()+AUTH+QUIT, nessuna email inviata.
     * Esegue solo l\&#39;handshake SMTP+AUTH. Nessuna email inviata, nessun costo. 200 OK su successo, 422 con causa enumerata su errore.
     * @endpoint post /api/v1/gestione/comuni/{id}/configurazione-mail/validate
* @param requestParameters
     */
    validateComuneConfigurazioneMail(requestParameters: ValidateComuneConfigurazioneMailRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneTestResponse>;

    /**
     * Validate login-only configurazione SMS del Comune (SUPERADMIN). Solo Aruba /login, nessun SMS inviato.
     * Esegue solo il GET Aruba /login. Nessun SMS inviato, nessun costo. 200 OK su successo, 422 con causa su errore.
     * @endpoint post /api/v1/gestione/comuni/{id}/configurazione-sms/validate
* @param requestParameters
     */
    validateComuneConfigurazioneSms(requestParameters: ValidateComuneConfigurazioneSmsRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneTestResponse>;

}
